export function formatWithCommas(value) {
  if (value === null || value === undefined || value === "" || value === 0)
    return "";

  // Allow partial decimal input (e.g. "1000.")
  const isTrailingDot = value.endsWith(".");

  // Remove commas for parsing
  const raw = value.toString().replace(/,/g, "");

  // If not a valid number (except just a dot), return raw input
  if (raw === "." || isNaN(raw)) return value;

  const num = parseFloat(raw);

  let formatted = num.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 8, // Adjust precision as needed
  });

  if (isTrailingDot) {
    formatted += ".";
  }

  // Preserve decimal part if user is typing it (e.g. "0.01", "1000.12")
  const [, decimalPart] = raw.split(".");
  if (decimalPart && !isTrailingDot) {
    const [intPart] = formatted.split(".");
    formatted = `${intPart}.${decimalPart}`;
  }

  return formatted;
}
